import {
    Component,
    OnInit,
    ViewChild,
    AfterViewInit,
    ElementRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiEndPointConstants } from 'merlin-core';
import { OneTimeWizardService } from './one-time-wizard.service';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import {
    PopupConfig,
    PopupService,
    PopupType,
    UserProfileObject,
    UserService,
} from 'merlin-library';
import { LanguageSource, LocalizationService } from 'src/core/utilitites/localization.service';
import { IdentifierService, ToasterClass } from 'merlin-core';
import { environment } from 'src/environments/environment';
import { PdfJsViewerComponent } from 'ng2-pdfjs-viewer';
import { MsalService } from '@azure/msal-angular';
import $ from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { ClinicianApiEndPointConstants } from 'projects/clinician/src/app/utilitites/api-end-point-constants';
let proxy;
@Component({
    selector: 'one-time-wizard',
    templateUrl: './one-time-wizard.component.html',
    styleUrls: ['./one-time-wizard.component.scss'],
    standalone:false
})
export class OneTimeWizardComponent implements OnInit, AfterViewInit {
    userRecordId: number;
    isScroll = false;
    privacyChecked: boolean = false;
    @ViewChild('tcPdfViewer') tcPdfViewer: PdfJsViewerComponent;
    name = new FormControl('', Validators.required);
    footerData: any = [
        {
            url: '/terms-of-use',
            link: 'label.gb.terms_cond',
            clickFunction: this.websiteTermsClick,
        },
        {
            url: '/privacy-policy',
            link: 'label.gb.priv_policy',
            clickFunction: this.privacyPolicyClick,
            showClick: true,
        },
        {
            url: '/contact-us',
            link: 'label.gb.contact_us',
            clickFunction: this.contactUsClick,
        },
        {
            url: '/cardio-vascular',
            link: 'www.cardiovascular.abbott',
            clickFunction: this.websiteMoreInfoClick,
            showClick: true,
        },
    ];
    footerCopyRights: any = [
        { linkText: 'Merlin.net\u2122 \u00A9 2021 Abbott' },
    ];
    fooMenuClass = '';
    fooCopyrightClass = '';
    userProfile: any;
    url: string;
    clinicCountry: string = 'US';
    payload;
    disableButton = false;
    signature: any;
    validateScroll = [];
    isTcPdfLoaded: boolean = false;
    returnUrl: any;
    otwForm: FormGroup;
    submitted = false;
    errorMsgEmail: any;
    primaryEmailAddress: any;
    mainPhone: any;
    secondaryPhone: any;
    smsPhone: any;
    otwpayload;
    invalidPhoneNumber: boolean = false;
    genError: boolean = false;
    uniqueMfaEmailFlg: any;
    fieldName: {};
    emailPattern =
    /^([a-zA-Z0-9!#$%&'*+/=?^_`{|}~.\-]+)@(($begin:math:display$[0-9]{1,3}(\\.[0-9]{1,3}){3}$end:math:display$)|(([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,63}))(\s*(;|,)\s*|\s*)$/;

    constructor(
        private router: Router,
        private otwService: OneTimeWizardService,
        public popupService: PopupService,
        private localizationService: LocalizationService,
        public identifierService: IdentifierService,
        private userService: UserService,
        private msalService: MsalService,
        private ele: ElementRef,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private toastrSer: ToastrService,
    ) { }
    translate(key: string): any {
        return this.localizationService.generateLocalizedStr(key, '', 'html');
    }
    ngOnInit(): void {
        this.otwForm = this.fb.group({
            emailAddress: [{value: '', disabled: true}, [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]],
            mfaEmailAddress: ['', [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]],
            mainPhone: [''],
            secondaryPhone: [''],
            smsPhone: [''],
        });
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || ApiEndPointConstants.quickLinkDashboardURL;
        this.userService
            .getUserProfile(false)
            .subscribe((userProfile) => {
                this.userProfile = userProfile;
                const locale = userProfile?.locale;
                this.localizationService.setLanguage(
                    LanguageSource.UserDefined,
                    locale
                );
                this.primaryEmailAddress = this.userProfile.emailAddress;
                this.otwForm.controls['emailAddress'].setValue(this.primaryEmailAddress);
                this.mainPhone = this.userProfile.mainPhone;
                this.secondaryPhone = this.userProfile.secondaryPhone;
                this.smsPhone = this.userProfile.sms;
                this.callUserService();  
            });
            localStorage.removeItem('smsPhone');
            localStorage.removeItem('secondaryPhone');
            localStorage.removeItem('mainPhone');  
    }
    callUserService(){
        this.otwService
            .enablePrimaryEmail(this.primaryEmailAddress)
            .subscribe((res) => {
                this.uniqueMfaEmailFlg = res.uniqueMfaEmailFlg;                               
                if(this.uniqueMfaEmailFlg){
                    this.otwForm.controls['emailAddress'].disable();
                }
                else{
                    this.otwForm.controls['emailAddress'].enable();
                }
            }
            );
    }   
    
    getReqFieldsErrors(){
        const errors = [];
        const controls = this.otwForm.controls;
        for(const controlName in controls){
            if(controls.hasOwnProperty(controlName)){
                const control = controls[controlName];
                if(control.errors && control.errors.required){
                    errors.push(this.fieldName[controlName])
                }
            }
        }
        return errors;
    }
    getInvalidFieldsErrors(){
        const errors = [];
        const controls = this.otwForm.controls;
        for(const controlName in controls){
            if(controls.hasOwnProperty(controlName)){
                const control = controls[controlName];
                if(control.errors && control.errors.pattern){
                    errors.push(this.fieldName[controlName])
                }
            }
        }
        return errors;
    }
    translateinvalidPhoneNumberError() {
        let stringVal = this.localizationService.generateLocalizedStr(
            'msg.error_incorrect_phonenumber.text'
        );
        let splitStringVal = stringVal.split("{")[0];
        return splitStringVal;
    }
    invalidPhoneTostr() {        
        this.toastrSer.show(this.translateinvalidPhoneNumberError(), null, {
            enableHtml: true,
            tapToDismiss: false,
            disableTimeOut: false,
            toastClass: `${ToasterClass.userNotificationMessageA} ${ToasterClass.ngxToastr}`,
        });
      }
    onSubmit(form: FormGroup) {
        this.emailValidationMsg();
        this.invalidPhoneNumber = false;
        this.genError = false;
        this.submitted = true;
        if (this.otwForm.invalid) {
            return;
        }
        this.payload = {
            userRecord: {
                userRecordId: this.userProfile.userRecordId
            },
            mfaEmailAddress: form.value.mfaEmailAddress
            ,
            emailAddress: this.otwForm.get('emailAddress').value
        };
        this.otwService
            .emailValidate(this.payload)
            .subscribe((res) => {
                this.errorMsgEmail = res.errorMsgEmail;
                if (this.errorMsgEmail) {
                    return;
                }
                else {
                    this.otwpayload = {
                        mainPhoneOptedForMfa: this.otwForm.get('mainPhone').value,
                        secondaryPhoneOptedForMfa: this.otwForm.get('secondaryPhone').value,
                        smsOptedForMfa: this.otwForm.get('smsPhone').value,
                        mfaEmailAddress: this.otwForm.get('mfaEmailAddress').value,
                        emailAddress : this.otwForm.get('emailAddress').value
                    };
                    this.otwService
                        .setOneTimeWizardConsent(this.otwpayload)
                        .subscribe((res) => {
                            localStorage.removeItem('smsPhone');
                            localStorage.removeItem('secondaryPhone');
                            localStorage.removeItem('mainPhone');                            
                            this.router.navigate(['/one-time-wizard-success']);
                        },
                        (err) => {
                            let mainPhone_invalid = err.message.includes('InvalidMainPhone');
                            let bothPhone_invalid = err.message.includes('InvalidBothPhone'); 
                            let InvalidSecPhone = err.message.includes('InvalidSecPhone'); 
                            let resPhoneNums = err.phoneNums;
                            let resPhoneNumsSplit = resPhoneNums?.toString().split(",");                            
                            let firstRes = resPhoneNumsSplit[0]?.slice(-4);
                            let secRes = resPhoneNumsSplit[1]?.slice(-4);                                                   
                            let mainPhone = this.mainPhone?.slice(-4);
                            let secondaryPhone = this.secondaryPhone?.slice(-4);
                            let smsPhone = this.smsPhone?.slice(-4);  

                            if (mainPhone_invalid || bothPhone_invalid || InvalidSecPhone) {
                                this.invalidPhoneNumber = true;    
                                this.invalidPhoneTostr();
                                if(this.otwForm.get('mainPhone').value == false){
                                    this.otwForm.controls['mainPhone'].enable();
                                }               
                                if(this.otwForm.get('secondaryPhone').value == false){
                                    this.otwForm.controls['secondaryPhone'].enable();
                                }               
                                if(this.otwForm.get('smsPhone').value == false){
                                    this.otwForm.controls['smsPhone'].enable();
                                }               
                                if(mainPhone == firstRes || mainPhone == secRes){
                                    this.otwForm.controls['mainPhone'].disable();
                                    this.otwForm.get('mainPhone').setValue(false);  
                                    localStorage.setItem('mainPhone', 'mainPhoneDisabled')
                                }
                                else{
                                    localStorage.setItem('mainPhone', 'mainPhoneEnabled');
                                }
                                if(secondaryPhone == firstRes || secondaryPhone == secRes){
                                    this.otwForm.controls['secondaryPhone'].disable(); 
                                    this.otwForm.get('secondaryPhone').setValue(false);
                                    localStorage.setItem('secondaryPhone', 'secondaryPhoneDisabled');
                                }
                                else{
                                    localStorage.setItem('secondaryPhone', 'secondaryPhoneEnabled');
                                }
                                if(smsPhone == firstRes || smsPhone == secRes){
                                    this.otwForm.controls['smsPhone'].disable();  
                                    this.otwForm.get('smsPhone').setValue(false);  
                                    localStorage.setItem('smsPhone', 'smsPhoneDisabled');                                  
                                }                                
                                else{
                                    localStorage.setItem('smsPhone', 'smsPhoneEnabled');
                                }
                            }
                            else{
                                this.genError = true;
                            }
                        });
                }
            }
            );
    }
    checkboxCondition() {
         var checkedCheckboxes = $('input[type="checkbox"]:checked');
        if(localStorage?.getItem('mainPhone') == "mainPhoneDisabled" || localStorage?.getItem('secondaryPhone') == "secondaryPhoneDisabled" || localStorage?.getItem('smsPhone') == "smsPhoneDisabled"){
            return;
        }
        else{            
            if (checkedCheckboxes.length >= 2 ) {
                $('input[type="checkbox"]:not(:checked)').prop('disabled', true);
            } else {
                $('input[type="checkbox"]').prop('disabled', false);
            }
       }
    }
    translateEmailError() {
        let stringVal = this.localizationService.generateLocalizedStr(
            'msg.cs818.text'
        );
        let splitStringVal = stringVal.split("{")[0];
        return splitStringVal;
    }
    translateErrorMsgEmail() {
        let stringVal = this.localizationService.generateLocalizedStr(
            this.errorMsgEmail
        );
        let splitStringVal = stringVal.split("{")[0];
        return splitStringVal;
    }
    translateEmailInvalidError() {
        let stringVal = this.localizationService.generateLocalizedStr(
            'msg.cs816.text'
        );
        let splitStringVal = stringVal.split("{")[0];
        return splitStringVal;
    }
    emailValidationMsg(){
        this.fieldName = {
            emailAddress: this.translate('label.gb.email'),
            mfaEmailAddress: this.translate('label.gb.second_email')
        };
    }

    translateGenError() {
        let stringVal = this.localizationService.generateLocalizedStr(
            'label.gb.rp_gen_error'
        );
        let splitStringVal = stringVal.split("{")[0];
        return splitStringVal;
    }
    

    translateEmailTooltip() {
        let stringVal = this.localizationService.generateLocalizedStr(
            'label.gb.email_msg_tooltip'
        );
        return stringVal;
    }
    alternateEmailTooltip() {
        return this.localizationService.generateLocalizedStr(
            'label.gb.email_msg_tooltip_alt'
        );
    }
    getTooltip(key: string) {
        let stringVal = this.localizationService.generateLocalizedStr(key);
        return stringVal;
    }

    readAgainRef(message: string, type: PopupType) {
        const msg = this.translate(message);
        const dialogConfig: PopupConfig = {
            type: type,
            message: msg,
            confirmText: this.translate(
                'label.gb.ok'
            ),
            confirmId: this.identifierService.buttonId(
                'pcs-location-popup',
                'ok'
            ),
            cancelId: this.identifierService.buttonId(
                'pcs-location-popup',
                'cancel001'
            ),
            cancelText: this.translate(
                'label.gb.button_cancel'
            ),
            customPopup: true,
        };
        return dialogConfig;
    }
    declineRef(message: string, type: PopupType) {
        const msg = this.translate(message);
        const dialogConfig: PopupConfig = {
            type: type,
            message: msg,
            confirmText: this.translate(
                'label.gb.ok'
            ),
            confirmId: this.identifierService.buttonId(
                'pcs-location-popup',
                'Ok'
            ),
            cancelId: this.identifierService.buttonId(
                'pcs-location-popup',
                'cancel001'
            ),
            cancelText: this.translate(
                'label.gb.button_cancel'
            ),
            customPopup: true,
        };
        return dialogConfig;
    }
    //footer links
    websiteTermsClick() {
        window.open(
            environment.disclosureUrl + '/Terms_and_Conditions.pdf',
            '_blank'
        );
    }

    ngAfterViewInit() {
        proxy = this;
    }
    privacyPolicyClick() {
        window.open(
            environment.disclosureUrl + '/Privacy_Policy.pdf',
            '_blank'
        );
    }
    contactUsClick() {
        const title = 'Contact Information';
        var win = window.open(
            '',
            'UATRpt',
            'menubar=0,location=0,toolbar=0,resizable=1,status=1,scrollbars=1'
        );

        if (win.document) {
            win.document.write(
                '<html><head><title>' +
                title +
                '</title></head><body><img src="' +
                environment.disclosureUrl +
                '/' +
                'contact_us_text.gif' +
                '" width="70%"></body></html>'
            );
        }
        win.focus();
    }
    websiteMoreInfoClick() {
        window.open('https://www.cardiovascular.abbott', '_blank');
    }
}